// src/hooks/useAuthRedirect.ts
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const useAuthRedirect = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // Optional: Show loading state while checking

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user) {
        navigate("/admin-login"); // ✅ Redirect to dedicated admin login page
      } else {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  return { loading }; // Optional: return loading if you want to show a spinner
};

export default useAuthRedirect;
